/**
 * «Сайт и контент», когда блоков вопросов нет (флаг выключен, тариф ниже, шлюз
 * сервера закрыт): пояснение вместо чисел (решение владельца 28.09). Темы
 * разговоров (#845 PR 6) от вопросов не зависят — у них свой флаг и свой запрос:
 * при открытом флаге тем вкладка остаётся рабочей — панель фильтров, пояснение
 * и блок тем под ним. Флаг тем закрыт — только пояснение, без фильтров и
 * запросов.
 */
import { VoiceSiteClosedNotice } from './VoiceSiteClosedNotice';
import { VoiceSiteClosedWithThemes } from './VoiceSiteClosedWithThemes';
import { useVoiceThemesAvailable } from './themes/useVoiceThemes';
import type { VoiceSiteQuestionsProps } from './VoiceSiteQuestions';

export interface VoiceSiteClosedProps extends VoiceSiteQuestionsProps {
  /** Why there are no questions: switched off (or closed by the server) or the plan. */
  reason: 'off' | 'upgrade';
}

export function VoiceSiteClosed(props: VoiceSiteClosedProps) {
  const themesAvailable = useVoiceThemesAvailable();
  if (!themesAvailable) {
    return (
      <VoiceSiteClosedNotice
        reason={props.reason}
        withThemes={false}
        upgradeHref={props.upgradeHref}
      />
    );
  }
  return <VoiceSiteClosedWithThemes {...props} />;
}
